import { combineTransactionPromises } from "@bridgesplit/react";
import { Result } from "@bridgesplit/utils";
import {
    getRaydiumTransferPositionTransaction,
    getRaydiumUpdateLiquidityTransaction,
    TxnManageRaydiumLiquidityParams,
    TxnTransferRaydiumPositionParams
} from "@bridgesplit/abf-sdk";

import { useAbfFetches } from "../reducers";
import { AbfTransactionDetails, AbfGeneratorResult } from "../types";
import { useAbfGenerateTransaction } from "./common";

export function useRaydiumLiquidityTransaction(): AbfTransactionDetails<TxnManageRaydiumLiquidityParams> {
    const generate = useAbfGenerateTransaction();
    const { resetLoanApi, resetClmmPositions, resetLoanLuts } = useAbfFetches();

    async function getTransactionsWithParams(args: TxnManageRaydiumLiquidityParams): AbfGeneratorResult {
        try {
            const transaction = generate({
                generateFunction: getRaydiumUpdateLiquidityTransaction,
                identifier: "Update liquidity",
                params: args
            });

            const transactions = await combineTransactionPromises([transaction], { order: "sequential" });
            return transactions;
        } catch (error) {
            return Result.err(error);
        }
    }

    const sendOptions = {
        refetch: () => {
            resetLoanApi();
            resetClmmPositions();
            resetLoanLuts();
        }
    };

    return { getTransactionsWithParams, sendOptions, description: "Update liquidity" };
}

export function useRaydiumUpdatePositionTransaction(): AbfTransactionDetails<TxnTransferRaydiumPositionParams> {
    const generate = useAbfGenerateTransaction();
    const { resetLoanApi, resetClmmPositions, resetLoanLuts } = useAbfFetches();

    async function getTransactionsWithParams(args: TxnTransferRaydiumPositionParams): AbfGeneratorResult {
        try {
            const transaction = generate({
                generateFunction: getRaydiumTransferPositionTransaction,
                identifier: "Update position",
                params: args
            });

            const transactions = await combineTransactionPromises([transaction], { order: "sequential" });
            return transactions;
        } catch (error) {
            return Result.err(error);
        }
    }

    const sendOptions = {
        refetch: () => {
            resetLoanApi();
            resetClmmPositions();
            resetLoanLuts();
        }
    };

    return { getTransactionsWithParams, sendOptions, description: "Update position" };
}
